import React from 'react';
import { Link } from 'react-router-dom';
const links = [{
  label: 'Video',
  href: '/#video'
}, {
  label: 'Checkliste',
  href: '/#checkliste'
}, {
  label: 'Vergleich',
  href: '/#vergleich'
}, {
  label: 'Ablauf',
  href: '/#ablauf'
}, {
  label: 'Über uns',
  href: '/#ueber-uns'
}, {
  label: 'FAQ',
  href: '/#faq'
}];
export function Navigation() {
  return <nav aria-label="Hauptnavigation" className="fixed top-0 left-0 right-0 z-50 bg-[#0a0e1a]/95 backdrop-blur-sm border-b border-white/5" data-id="element-168" data-mp="3shkz15myvfwp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169" data-mp="59r0ffqfn1gg">
        <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-170" data-mp="jzf6svdh0qb1">
          <Link to="/" className="flex items-center gap-2" aria-label="Startseite" data-id="element-171" data-mp="k1rnz6bemwn1">
            <span className="text-xl font-bold text-white" data-id="element-172" data-mp="f1dls4whigwx">CRM</span>
            <span className="text-xl font-bold text-[#ff6b35]" data-id="element-173" data-mp="t1em9j8u7mbv">Kraft</span>
          </Link>

          <ul className="hidden lg:flex items-center gap-8" data-id="element-174" data-mp="ozkrfrlbpcjm">
            {links.map(link => <li key={link.href} data-id="element-175" data-mp="dghbp8x0524a">
                <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap" data-id="element-176" data-mp="dhik15mmvaib">
                  {link.label}
                </a>
              </li>)}
          </ul>

          <a href="/#termin" className="bg-[#ff6b35] hover:bg-[#ff5722] text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap" data-id="element-177" data-mp="rg9wknluko4c">
            Termin buchen
          </a>
        </div>
      </div>
    </nav>;
}